import { Route, Redirect } from "react-router-dom";
import { useAppContext } from "../Libs/contextLib";

export default function AuthenticatedRoute({
	component: C,
	appProps,
	...rest
}) {
	const { isAuthenticated } = useAppContext();
	return (
		<Route
			{...rest}
			render={(props) =>
				isAuthenticated ? (
					<C {...props} {...appProps} />
				) : (
					<Redirect
						to={`/Error?redirect=${props.location.pathname}${props.location.search}`}
					/>
				)
			}
		/>
	);
}
